export const HAZARD_FIELD = {
  name: 'hazards__name',
  id: 'hazards__id',
  category: 'hazards__category',
  whoMightBeHarmed: 'hazards__whoMightBeHarmed',
  howMightBeHarmed: 'hazards__howMightBeHarmed',
} as const;

export enum HazardStatusFilter {
  Active = 'active',
  Archived = 'archived',
}

export const HAZARD_STATUS_LABEL: Record<HazardStatusFilter, string> = {
  [HazardStatusFilter.Active]: 'Active',
  [HazardStatusFilter.Archived]: 'Archived',
};

export const ARCHIVE_CONFIRMATION_MESSAGE =
  'It stays in the assessments and templates that already use it, but no one can add it to anything new. You can unarchive it at any time.';
